'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import Footer from '@pc/components/organisms/footer/Footer';
import SideBar from '@pc/components/organisms/sidebar/SideBar';
import TopNavContainer from '@pc/components/top-nav/TopNavContainer';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';
interface LayoutWrapperProps {
  children: React.ReactNode;
}
const ASPNavbar = dynamic(() => import('@pc/components/ASP/ASPNavbar'), {
  ssr: false
});
const LayoutWrapper = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const {
    siteMode,
    isLogin
  } = useGetLoginInfoQuery();
  const shouldHideSideBarForVMode = siteMode?.mode === "v" && !isLogin;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TopNavContainer />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== shouldHideSideBarForVMode) {
    t2 = !shouldHideSideBarForVMode && <SideBar />;
    $[1] = shouldHideSideBarForVMode;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Suspense fallback={null}><ASPNavbar /></Suspense>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Footer />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children) {
    t5 = <section className="relative mx-auto mt-16 flex h-full w-full max-w-[2332px]" id="main-container" data-testid="main-content"><div className="flex flex-grow flex-col justify-between">{t3}{children}{t4}</div></section>;
    $[5] = children;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <div id="wrapper" className="relative h-full w-full min-w-[1300px] pl-[228px]">{t1}{t2}{t5}</div>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export default LayoutWrapper;